<template>
    <v-container :fluid="$vuetify.breakpoint.md" class="mb-12 mb-lg-0">
        <v-row justify="center">
            <v-col cols="12">
                <v-card width="100%">
                    <v-card-title class="d-block text-center font-weight-bold primary white--text py-0" style="word-break: normal">Servicio Nº {{ id.length < 5 ? ('0000' + id).slice(-4) : id }}</v-card-title>
                </v-card>
            </v-col>
        </v-row>
        <v-row justify="center">
            <v-col cols="12">
                <v-card>
                    <v-card-title class="d-block text-center font-weight-bold primary white--text py-2" style="word-break: normal">ESTADO: {{ service.status_name ? service.status_name.toUpperCase() : '' }}</v-card-title>
                    <v-divider/>
                    <v-card-text>
                        <v-row justify="center">
                            <v-col cols="12" md="10" class="text-center">
                                <h3>{{ service.name }}</h3>
                            </v-col>
                            <v-col cols="12" md="10" class="text-center">
                                <p><strong>Descripción:</strong> {{ service.content }}</p>
                            </v-col>
                            <v-col cols="12" md="10" class="text-center">
                                <h3><u>Progreso del Caso</u></h3>
                            </v-col>
                            <v-col cols="12" md="10">
                                <v-timeline class="pt-3" dense clipped>
                                    <template v-for="item in movements">
                                        <v-timeline-item class="pb-3" :key="item.id" small>
                                            <v-row justify="space-between">
                                                <v-col cols="7">{{ item.text }}</v-col>
                                                <v-col class="text-right" cols="5">{{ item.date }}<br/>{{ item.time }}</v-col>
                                            </v-row>
                                        </v-timeline-item>
                                    </template>
                                </v-timeline>
                            </v-col>
                        </v-row>
                        <v-row justify="center">
                            <v-col cols="12" md="10" class="text-center pt-8">
                                <v-btn color="error" dark to="/services">
                                    <v-icon>mdi-close-circle</v-icon>&nbsp;&nbsp;Volver
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import axios from 'axios';

    export default {
        name: "ServiceView",
        props: ['user'],
        data: () => ({
            id: 0,
            service: {},
            movements: {}
        }),
        created() {
            this.id = this.$route.params.id;
        },
        mounted () {
            this.getData();
        },
        methods: {
            getData() {
                clearTimeout(this.timeout);
                axios.get('/api/services/' + this.id).then((res) => {
                    if (res.data.v === 'success') {
                        this.service = res.data.service;
                        this.movements = res.data.movements;
                    } else {
                        this.$toast.warning(res.data.status, {icon: 'mdi-information'});
                    }
                }).catch(err => {
                    this.handleErrors(err.response.data.errors);
                }).then(() => {
                    this.loading = false;
                });
                this.timeout = setTimeout(this.getData, 150000);
            }
        },
        destroyed() {
            clearTimeout(this.timeout);
        }
    }
</script>

<style scoped>

</style>
